// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Dict = require("@rescript/runtime/lib/js/Stdlib_Dict.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let RelayRuntime = require("relay-runtime");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let Primitive_exceptions = require("@rescript/runtime/lib/js/Primitive_exceptions.js");
let FetchMultipartGraphql = require("fetch-multipart-graphql").default;

let ExpectedList = /* @__PURE__ */Primitive_exceptions.create("RelayNetworkUtils.ExpectedList");

function isInitialIncrementalExecutionResult(result) {
  if (typeof result === "object" && result !== null && !Array.isArray(result)) {
    if (result.data !== undefined) {
      return true;
    } else {
      return result.errors !== undefined;
    }
  } else {
    return false;
  }
}

function decodePathSegment(value) {
  switch (typeof value) {
    case "string" :
      return {
        TAG: "Field",
        _0: value
      };
    case "number" :
      let index = value | 0;
      if (index === value) {
        return {
          TAG: "Index",
          _0: index
        };
      } else {
        return;
      }
    default:
      return;
  }
}

function decodePath(value) {
  if (!Array.isArray(value)) {
    return;
  }
  let decodedPath = value.map(decodePathSegment);
  if (decodedPath.every(Stdlib_Option.isSome)) {
    return Stdlib_Array.keepSome(decodedPath);
  }
}

function pathToJson(path) {
  return path.map(segment => {
    if (segment.TAG === "Field") {
      return segment._0;
    } else {
      return segment._0;
    }
  });
}

function decodePendingPart(value) {
  if (typeof value !== "object" || value === null || Array.isArray(value)) {
    return;
  }
  let id = value.id;
  if (typeof id !== "string") {
    return;
  }
  let pathValue = value.path;
  if (pathValue === undefined) {
    return;
  }
  let path = decodePath(pathValue);
  if (path === undefined) {
    return;
  }
  let label;
  if (typeof value === "object" && value !== null && !Array.isArray(value)) {
    let label$1 = value.label;
    label = typeof label$1 === "string" ? label$1 : undefined;
  } else {
    label = undefined;
  }
  return {
    id: id,
    path: path,
    label: label,
    data: {}
  };
}

function decodeIncrementalUpdate(value) {
  if (typeof value !== "object" || value === null || Array.isArray(value)) {
    return;
  }
  let id = value.id;
  if (typeof id === "string") {
    let data = value.data;
    if (data !== undefined) {
      let tmp;
      if (typeof value === "object" && value !== null && !Array.isArray(value)) {
        let subPathValue = value.subPath;
        tmp = subPathValue !== undefined ? Stdlib_Option.getOr(decodePath(subPathValue), []) : [];
      } else {
        tmp = [];
      }
      return {
        TAG: "DataUpdate",
        id: id,
        data: data,
        subPath: tmp
      };
    }
  }
  let id$1 = value.id;
  if (typeof id$1 !== "string") {
    return;
  }
  let items = value.items;
  if (Array.isArray(items)) {
    return {
      TAG: "ItemsUpdate",
      id: id$1,
      items: items
    };
  }
}

function decodeIncrementalLabel(value) {
  if (typeof value !== "object" || value === null || Array.isArray(value)) {
    return;
  }
  let label = value.label;
  if (typeof label === "string") {
    return label;
  }
}

function decodeCompletedId(value) {
  if (typeof value !== "object" || value === null || Array.isArray(value)) {
    return;
  }
  let id = value.id;
  if (typeof id === "string") {
    return id;
  }
}

function getAtPath(root, path) {
  return Stdlib_Array.reduce(path, root, (current, segment) => Stdlib_Option.flatMap(current, value => {
    if (Array.isArray(value)) {
      if (segment.TAG === "Field") {
        return;
      }
      let index = segment._0;
      if (index < 0) {
        return;
      } else {
        return value[index];
      }
    }
    switch (typeof value) {
      case "object" :
        if (segment.TAG === "Field") {
          return value[segment._0];
        } else {
          return;
        }
      default:
        return;
    }
  }));
}

function ensureObjectAtPath(_root, path, _currentIndex) {
  while (true) {
    let currentIndex = _currentIndex;
    let root = _root;
    if (currentIndex >= path.length) {
      if (typeof root === "object" && root !== null && !Array.isArray(root)) {
        return root;
      } else {
        return;
      }
    }
    let match = path[currentIndex];
    if (typeof root !== "object" || root === null || Array.isArray(root)) {
      return;
    }
    if (match === undefined) {
      return;
    }
    if (match.TAG !== "Field") {
      return;
    }
    let fieldName = match._0;
    let match$1 = root[fieldName];
    let nextObject;
    let exit = 0;
    if (typeof match$1 === "object" && match$1 !== null && !Array.isArray(match$1)) {
      nextObject = match$1;
    } else {
      exit = 1;
    }
    if (exit === 1) {
      let created = {};
      root[fieldName] = created;
      nextObject = created;
    }
    _currentIndex = currentIndex + 1 | 0;
    _root = nextObject;
    continue;
  };
}

function mergeJsonObjects(target, patch) {
  if (typeof target !== "object" || target === null || Array.isArray(target)) {
    return;
  }
  if (typeof patch !== "object" || patch === null || Array.isArray(patch)) {
    return;
  }
  Object.assign(target, patch);
}

function withIsFinalExtension(result) {
  let hasNext;
  if (typeof result === "object" && result !== null && !Array.isArray(result)) {
    let hasNext$1 = result.hasNext;
    hasNext = hasNext$1 === true;
  } else {
    hasNext = false;
  }
  let extensions;
  if (typeof result === "object" && result !== null && !Array.isArray(result)) {
    let existingExtensions = result.extensions;
    extensions = typeof existingExtensions === "object" && existingExtensions !== null && !Array.isArray(existingExtensions) ? Object.assign({}, existingExtensions) : ({});
  } else {
    extensions = {};
  }
  extensions["is_final"] = !hasNext;
  return extensions;
}

function makePayload(data, extensions, errorsOpt, pathOpt, labelOpt) {
  let errors = errorsOpt !== undefined ? Primitive_option.valFromOption(errorsOpt) : undefined;
  let path = pathOpt !== undefined ? Primitive_option.valFromOption(pathOpt) : undefined;
  let label = labelOpt !== undefined ? Primitive_option.valFromOption(labelOpt) : undefined;
  let fields = Stdlib_Array.keepSome([
    [
      "data",
      data
    ],
    [
      "extensions",
      extensions
    ],
    Stdlib_Option.map(errors, errors => [
      "errors",
      errors
    ]),
    Stdlib_Option.map(path, path => [
      "path",
      pathToJson(path)
    ]),
    Stdlib_Option.map(label, label => [
      "label",
      label
    ])
  ]);
  return Object.fromEntries(fields);
}

function mergeDataAtPath(transformer, path, data) {
  if (path.length === 0) {
    let match = transformer.dataTree;
    if (typeof match === "object" && match !== null && !Array.isArray(match) && typeof data === "object" && data !== null && !Array.isArray(data)) {
      return mergeJsonObjects(transformer.dataTree, data);
    } else {
      transformer.dataTree = data;
      return;
    }
  }
  let target = getAtPath(transformer.dataTree, path);
  if (target !== undefined) {
    return mergeJsonObjects(target, data);
  }
}

function appendItemsAtPath(transformer, path, label, items, extensions) {
  let match = getAtPath(transformer.dataTree, path);
  if (match !== undefined) {
    if (Array.isArray(match)) {
      let currentIndex = {
        contents: match.length
      };
      items.forEach(item => {
        match.push(item);
        let itemPath = path.concat([{
            TAG: "Index",
            _0: currentIndex.contents
          }]);
        transformer.next(makePayload(item, extensions, undefined, Primitive_option.some(itemPath), Primitive_option.some(label)));
        currentIndex.contents = currentIndex.contents + 1 | 0;
      });
      return;
    }
    throw {
      RE_EXN_ID: ExpectedList,
      _1: "Expected a list",
      Error: new Error()
    };
  }
  throw {
    RE_EXN_ID: ExpectedList,
    _1: "Expected a list",
    Error: new Error()
  };
}

function makeRelayIncrementalDeliveryTransformer(next) {
  return {
    pendingParts: {},
    dataTree: {},
    next: next
  };
}

function fetchGraphQL(graphqlEndpoint, headersOpt, request, variables) {
  let headers = headersOpt !== undefined ? headersOpt : ({
      "content-type": "application/json"
    });
  return RelayRuntime.Observable.create(sink => {
    let transformer = makeRelayIncrementalDeliveryTransformer(payload => sink.next(payload));
    let body = {
      variables: variables,
      operationName: request.name
    };
    let id = request.id;
    if (id == null) {
      id === null;
    } else {
      body["id"] = id;
    }
    let text = request.text;
    if (text == null) {
      text === null;
    } else {
      body["query"] = text;
    }
    FetchMultipartGraphql(graphqlEndpoint, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
      credentials: "same-origin",
      onNext: parts => {
        parts.forEach(part => {
          if (typeof part !== "object" || part === null || Array.isArray(part)) {
            return;
          }
          let isInitialResult = isInitialIncrementalExecutionResult(part);
          let extensions = withIsFinalExtension(part);
          if (isInitialResult) {
            let initialData;
            if (typeof part === "object" && part !== null && !Array.isArray(part)) {
              let data = part.data;
              initialData = data !== undefined ? data : null;
            } else {
              initialData = null;
            }
            let errors;
            if (typeof part === "object" && part !== null && !Array.isArray(part)) {
              let errors$1 = part.errors;
              errors = errors$1 !== undefined ? errors$1 : undefined;
            } else {
              errors = undefined;
            }
            transformer.dataTree = initialData;
            transformer.next(makePayload(initialData, extensions, Primitive_option.some(errors), undefined, undefined));
          }
          if (typeof part === "object" && part !== null && !Array.isArray(part)) {
            let pendingResults = part.pending;
            if (Array.isArray(pendingResults)) {
              pendingResults.forEach(pending => {
                let pendingPart = decodePendingPart(pending);
                if (pendingPart !== undefined) {
                  transformer.pendingParts[pendingPart.id] = pendingPart;
                  return;
                }
              });
            }
          }
          if (isInitialResult) {
            return;
          }
          if (typeof part === "object" && part !== null && !Array.isArray(part)) {
            let incrementalResults = part.incremental;
            if (Array.isArray(incrementalResults)) {
              incrementalResults.forEach(incremental => {
                if (typeof incremental === "object" && incremental !== null && !Array.isArray(incremental)) {
                  let pathValue = incremental.path;
                  let exit = 0;
                  if (pathValue !== undefined) {
                    let data = incremental.data;
                    if (data !== undefined) {
                      let path = decodePath(pathValue);
                      if (path === undefined) {
                        return;
                      }
                      let label = decodeIncrementalLabel(incremental);
                      mergeDataAtPath(transformer, path, data);
                      return transformer.next(makePayload(data, extensions, undefined, Primitive_option.some(path), Primitive_option.some(label)));
                    }
                    exit = 2;
                  } else {
                    exit = 2;
                  }
                  if (exit === 2) {
                    let pathValue$1 = incremental.path;
                    if (pathValue$1 !== undefined) {
                      let items = incremental.items;
                      if (Array.isArray(items)) {
                        let path$1 = decodePath(pathValue$1);
                        if (path$1 === undefined) {
                          return;
                        }
                        let label$1 = decodeIncrementalLabel(incremental);
                        return appendItemsAtPath(transformer, path$1, label$1, items, extensions);
                      }
                    }
                  }
                }
                let match = decodeIncrementalUpdate(incremental);
                if (match === undefined) {
                  return;
                }
                if (match.TAG === "DataUpdate") {
                  let subPath = match.subPath;
                  let data$1 = match.data;
                  let pendingPart = transformer.pendingParts[match.id];
                  if (pendingPart === undefined) {
                    return;
                  }
                  let valueAtPendingPath = getAtPath(transformer.dataTree, pendingPart.path);
                  let dataTreeTarget = valueAtPendingPath !== undefined ? (
                      subPath.length === 0 ? valueAtPendingPath : getAtPath(valueAtPendingPath, subPath)
                    ) : undefined;
                  let pendingDataTarget = subPath.length === 0 ? pendingPart.data : ensureObjectAtPath(pendingPart.data, subPath, 0);
                  if (pendingDataTarget !== undefined && dataTreeTarget !== undefined) {
                    mergeJsonObjects(pendingDataTarget, data$1);
                    return mergeJsonObjects(dataTreeTarget, data$1);
                  } else {
                    return;
                  }
                }
                let pendingPart$1 = transformer.pendingParts[match.id];
                if (pendingPart$1 !== undefined) {
                  return appendItemsAtPath(transformer, pendingPart$1.path, pendingPart$1.label, match.items, extensions);
                }
              });
            }
          }
          if (typeof part !== "object" || part === null || Array.isArray(part)) {
            return;
          }
          let completedResults = part.completed;
          if (!Array.isArray(completedResults)) {
            return;
          }
          completedResults.forEach(completed => {
            let completedId = decodeCompletedId(completed);
            if (completedId === undefined) {
              return;
            }
            let pendingPart = transformer.pendingParts[completedId];
            if (pendingPart === undefined) {
              return;
            }
            let match = getAtPath(transformer.dataTree, pendingPart.path);
            let exit = 0;
            if (Array.isArray(match)) {
              transformer.next(makePayload(null, extensions, undefined, undefined, undefined));
            } else {
              exit = 1;
            }
            if (exit === 1) {
              transformer.next(makePayload(pendingPart.data, extensions, undefined, Primitive_option.some(pendingPart.path), Primitive_option.some(pendingPart.label)));
            }
            Stdlib_Dict.$$delete(transformer.pendingParts, completedId);
          });
        });
      },
      onError: error => sink.error(error),
      onComplete: () => sink.complete()
    });
  });
}

exports.fetchGraphQL = fetchGraphQL;
/* relay-runtime Not a pure module */
